import * as FluxUtils from 'flux/utils';
import { ActionConstants } from '../constants/ActionConstants';
import { DispatcherBaseAction, AppDispatcher } from '../dispatcher/AppDispatcher';

interface CustomStoreState {
    [id: string]: any;
}

class CustomStoreClass extends FluxUtils.ReduceStore<CustomStoreState, unknown> {
    public getInitialState(): CustomStoreState {
        return {
        };
    }

    public getCustomState(key: string): {} {
        const state: CustomStoreState = this.getState();
        if (state[key] == null) {
            return {};
        }
        return state[key];
    }

    public reduce(state: CustomStoreState, action: DispatcherBaseAction): CustomStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.SAVE_DATA:
                if (action.value == null || action.value.key == null) {
                    return state;
                }
                const payload: {[id: string]: unknown} = {};
                payload[action.value.key] = action.value.payload;
                return jQuery.extend({}, state, payload);
            default:
                return state;
        }

    }
}

export let CustomStore: CustomStoreClass = new CustomStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CustomStore.ts